import React, { useEffect, useState } from 'react';

function HeroSliderNew({ onNavigate }) {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=2070",
      title: "BUILDING",
      subtitle: "INFRASTRUCTURE",
      description: "Specializing in construction, interiors, modernization, and turnkey project execution across India since 2000.",
      cta: "VIEW PROJECTS",
      action: () => onNavigate && onNavigate('projects_page')
    },
    {
      image: "/assets/RIPL%20Projects/Interiors/SBI%20Reception%20Lobby%2C%20State%20Bank%20Bhavan%2C%20Mumbai/6.png",
      title: "EXCELLENCE IN",
      subtitle: "DESIGN & EXECUTION",
      description: "Delivering innovative solutions for government institutions, public sector undertakings, and corporate clients.",
      cta: "OUR SERVICES",
      action: () => {
        const element = document.getElementById('services');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
    {
      image: "https://images.unsplash.com/photo-1577495508048-b635879837f1?auto=format&fit=crop&q=80&w=2070",
      title: "TRUSTED",
      subtitle: "PARTNER",
      description: "Creating lasting infrastructure with quality, timely delivery, and unwavering commitment to excellence.",
      cta: "ABOUT US",
      action: () => onNavigate && onNavigate('about_page')
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlideIndex = (currentSlide + 1) % slides.length;

  return (
    <section className="hero-slider-container">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`hero-slide ${currentSlide === index ? 'active' : ''}`}
          style={
            index === currentSlide || index === nextSlideIndex
              ? { backgroundImage: `url('${slide.image}')` }
              : undefined
          }
        />
      ))}

      <div className="hero-content-wrapper">
        <div className="max-w-4xl">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`slide-text-group ${currentSlide === index ? 'active' : ''}`}
            >
              <h1 className="bank-gothic mb-5 text-3xl leading-tight sm:text-4xl md:mb-6 md:text-7xl">
                {slide.title} <br />
                <span className="text-neutral-400">{slide.subtitle}</span>
              </h1>
              <p className="mb-8 max-w-xl text-sm font-light leading-relaxed text-neutral-300 md:mb-10 md:text-base">
                {slide.description}
              </p>
              <button onClick={slide.action} className="btn-outline bank-gothic">
                {slide.cta} {'\u00a0\u2192'}
              </button>
            </div>
          ))}
        </div>
      </div>

      <div className="slider-nav">
        <div className="flex items-center space-x-4">
          {slides.map((_, index) => (
            <div
              key={index}
              className={`slide-indicator ${currentSlide === index ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            >
              <div className="indicator-progress"></div>
            </div>
          ))}
        </div>
        <div className="hidden bank-gothic text-[10px] tracking-widest text-neutral-500 md:block">
          <span>{String(currentSlide + 1).padStart(2, '0')}</span> / {String(slides.length).padStart(2, '0')}
        </div>
      </div>
    </section>
  );
}

export default HeroSliderNew;
